import { render } from "./PinCodeTicket.vue?vue&type=template&id=2d9c0103"
import script from "./PinCodeTicket.vue?vue&type=script&lang=js"
export * from "./PinCodeTicket.vue?vue&type=script&lang=js"
script.render = render

export default script